import React from "react";

const VersionServicesContext = React.createContext({});

export default VersionServicesContext;